import { createContext, useState } from 'react';

export const AgentContext = createContext({
    providedAgent: 0,
    setProvidedAgent: (agent: number) => {}
});

export const AgentProvider = ({ children }) => {
    const [currentAgent, setCurrentAgent] = useState(0);

    return (
        <AgentContext.Provider
            value={{
                providedAgent: currentAgent,
                setProvidedAgent: setCurrentAgent
            }}
        >
            {children}
        </AgentContext.Provider>
    );
};
